module.exports = "<p>error-modal works!</p>\r\n"